import classNames from 'classnames';
import React from 'react';
type Props = {
    className?: string;
};
const ArrowIcon = ({ className }: Props) => (
    <svg className={classNames(className)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96">
        <path d="M87.77,46.46,66.6,25.29a2,2,0,0,0-2.83,0l-3.54,3.54a2,2,0,0,0,0,2.83L72.58,44H10a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2H71.34L60.23,64.1a2,2,0,0,0,0,2.83l3.54,3.54a2,2,0,0,0,2.83,0L87.77,49.3a2,2,0,0,0,0-2.84Z" />
    </svg>
);

export default React.memo(ArrowIcon);
